import {
  treatsItem,
  treatsItems,
} from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import ActionPlansAPI from '@/services/api/internal/actionplans.api';

const ActionPlansService = new BaseService({
  api: ActionPlansAPI,
  urlParamsItems: { expand: 'properties' },
  urlParamsCurrent: { expand: 'actions' },
  treatListResponse: treatsItems({
    datetimeFieldNames: [
      'creation_datetime',
      'start_datetime',
      'end_datetime',
      {
        arrayFieldName: 'action_plan_origins',
        arrayFields: ['datetime'],
      },
    ],
  }),
  treatCurrentResponse: treatsItem({
    datetimeFieldNames: ['creation_datetime', 'start_datetime', 'end_datetime'],
  }),
  treatCreateResponse: treatsItem({
    datetimeFieldNames: ['creation_datetime', 'start_datetime', 'end_datetime'],
  }),
});

export default ActionPlansService;
